import { SocialLinks } from 'govbr.frontend.policy/components';
import { defineMessages, useIntl } from 'react-intl';

import styles from './Info.module.less';

const messages = defineMessages({
  useOurDirectChannels: {
    id: 'You can also use our direct channels to talk to ',
    defaultMessage: 'You can also use our direct channels to talk to ',
  },
  useOurDirectChannelsNoEmail: {
    id: 'You can contact ',
    defaultMessage: 'You can contact ',
  },
  ourDirectChannels: {
    id: ' through the direct channels:',
    defaultMessage: ' through the direct channels:',
  },
  contactEmail: {
    id: 'Contact e-mail',
    defaultMessage: 'Contact e-mail',
  },
  phoneNumber: {
    id: 'Phone number',
    defaultMessage: 'Phone number',
  },
  socialNetworks: {
    id: 'Social networks',
    defaultMessage: 'Social networks',
  },
  otherServiceInformation: {
    id: 'Other service information',
    defaultMessage: 'Other service information',
  },
  contactFormNotConfigured: {
    id: 'Contact form not configured',
    defaultMessage: 'Contact form not configured',
  },
});

const Info = ({ 'contact-info': contactInfo = {}, 'site-name': siteName }) => {
  const intl = useIntl();

  const { phone_number, other_informations, email, article } = contactInfo;

  if (!phone_number && !other_informations && !email) {
    return null;
  }

  return (
    <div className={styles.info}>
      {email ? (
        <>
          <div className={styles.field}>
            {intl.formatMessage(messages.useOurDirectChannels)}
            {article ? article : null} <strong>{siteName}</strong>.
          </div>
          <div className={styles.field}>
            <div className={styles.label}>
              {intl.formatMessage(messages.contactEmail)}
            </div>
            <div className={styles.value}>{email}</div>
          </div>
        </>
      ) : (
        <div className={styles.field}>
          {intl.formatMessage(messages.useOurDirectChannelsNoEmail)}
          {article ? article : null} <strong>{siteName}</strong>
          {intl.formatMessage(messages.ourDirectChannels)}
        </div>
      )}
      {phone_number ? (
        <div className={styles.field}>
          <div className={styles.label}>
            {intl.formatMessage(messages.phoneNumber)}
          </div>
          <div className={styles.value}>{phone_number}</div>
        </div>
      ) : null}

      <div className={styles.field}>
        <SocialLinks
          labelClassName={styles.label}
          label={intl.formatMessage(messages.socialNetworks)}
        />
      </div>

      {other_informations ? (
        <div className={styles.field}>
          <div className={styles.label}>
            {intl.formatMessage(messages.otherServiceInformation)}
          </div>
          <div className={styles.value}>
            {other_informations.split('\n').map((line, i) => (
              <div key={i}>{line}</div>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Info;
